<Title>
  Crop and Position
  <span slot="subtitle">Drag to position your image</span>
</Title>

<div class="ne-crop-container" data-test-component="photo-editor">
  <img class="ne-cropper-target" alt="uploaded image target" data-heap-photo-editor bind:this={cropperTarget} />
  <button class="ne-rotate-button" data-heap-rotate-photo on:click="{rotate}">
    <RotateIcon />
  </button>
</div>
<label class="ne-zoom">
  Zoom
  <input class="ne-zoom-control" data-heap-zoom-slider type="range" on:input='{zoom}' value='{$photo.zoomRatio.state}' min="0" max="2" step="0.0005" />
</label>

<style>
  .ne-crop-container {
    width: 300px;
    height: 300px;
    margin: auto;
    position: relative;
  }

  .ne-rotate-button {
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
    fill: #fff;
    background: none;
    border: none;
  }

  .ne-zoom {
    display: flex;
    width: 300px;
    margin: auto;
    align-items: center;
  }

  .ne-zoom-control {
    padding: .5em 0;
    margin-left: 1em;
    flex-grow: 1;
  }

 .ne-cropper-target {
    max-width: 100%
  }
</style>

<script>
  import Title from './Title.html';
  import RotateIcon from './RotateIcon.html';
  import Cropper from 'cropperjs';
  import '../../node_modules/cropperjs/dist/cropper.css';
  import { store, photo } from '../stores';
  import { onMount } from 'svelte';

  let cropperTarget;

  $: isVisible = $photo.isEditingPhoto.state;
  $: src = $photo.photoSrc.state;
  $: originalSrc = $photo.originalPhotoSrc.state;

  onMount(() => {
    const cropper = new Cropper(cropperTarget, {
      aspectRatio: 1 / 1,
      viewMode: 1,
      cropBoxMovable: false,
      cropBoxResizable: false,
      dragMode: 'move',
      minCropHeight: 250,
      minCropBoxWidth: 250,
      minContainerWidth: 300,
      minContainerHeight: 300,
      toggleDragModeOnDblclick: false,
      wheelZoomRatio: 0.05,
      ready: () => {
        const canvasData = cropper.getCanvasData();
        const ratio = canvasData.width / canvasData.naturalWidth;
        const zoom = originalSrc
          ? $photo.zoomRatio.state
          : ratio;

        cropper.zoomTo(zoom);
        cropper.rotateTo($photo.rotation.state);
        photo.set($photo.zoomRatio.set(zoom));
      }
    });

    const photoSrc = originalSrc ? originalSrc : src;
    cropper.replace(photoSrc);

    photo.set($photo.cropper.set(cropper));

    cropperTarget.addEventListener('zoom', zoomHandler);

    /* this runs on destroy of PhotoEditor */
    return () => {
      cropperTarget.removeEventListener('zoom', zoomHandler);
      const rotate = cropper.getData().rotate;
      cropper.destroy();
      photo.set($photo.cropper.set(null).rotation.set(rotate));
    }
  });

  function zoomHandler(event) {
    photo.set($photo.zoomRatio.set(event.detail.ratio));
  }

  function rotate() {
    $photo.cropper.state.rotate(90);
  }

  function zoom({ target: { value } }) {
    $photo.cropper.state.zoomTo(value);
    photo.set($photo.zoomRatio.set(value));
  }
</script>
